/* eslint-disable max-classes-per-file */
import type { HistoryGuestSearchInterface } from "@/app/[lang]/account/@content/booking/components/HistoryContactEditCompanent/HistoryContactEditFormCompanent";

import { ContactDatePresenter } from "./historyBookingCommonInterface";

export class ContactEditDatePresenter extends ContactDatePresenter {
  status: boolean;

  cToken: string;

  bookingInternalNo: string;

  pinCode: string;

  productType: string;

  constructor(data: any) {
    super(data);
    this.status = data?.status || false;
    this.cToken = data?.cToken || "";
    this.bookingInternalNo = data?.bookingInternalNo || "";
    this.pinCode = data?.pinCode || "";
    this.productType = data?.productType || "";
  }
}

export class RequestPostUpdateContactInterface {
  bookingInternalNo: string;

  contactEmail: string;

  contactPhonePrefix: string;

  contactPhone: string;

  cToken: string;

  constructor(
    formData: HistoryGuestSearchInterface,
    bookingData: { bookingInternalNo: string; cToken: string },
  ) {
    this.bookingInternalNo = bookingData.bookingInternalNo;
    this.contactEmail = formData.email;
    this.contactPhonePrefix = formData.prefixPhone;
    this.contactPhone = formData.phone;
    this.cToken = bookingData.cToken;
  }
}

export class ResponsePostUpdateContactInterface {
  status: boolean;

  code: string;

  message: string;

  constructor(response: any) {
    this.status = response?.status || false;
    this.code = response?.code || "";
    this.message = response?.message || "";
  }
}
